import React from 'react';
import classnames from 'classnames';

import './style.scss';

interface ChipProps {
  id: string;
  text: string;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Chip: React.FC<ChipProps> = ({
  id,
  text,
  checked = false,
  disabled = false,
  className,
  type,
  onChange,
}) => (
  <div className={classnames('Chip', className, { checked }, { disabled }, type ? `type-${type}` : 'type-basic')}>
    <input type="checkbox" name={id} id={id} onChange={onChange} checked={checked} disabled={disabled} />
    <label htmlFor={id}><div className="icon icon-check-radio icon-variant-1" />
      {text}
    </label>
    {type && (
      <span>
        <i className="icon icon-pin-outline icon-variant-1" />
      </span>
    )}
  </div>
);

export default Chip;
